<template>
    <div class="record-materials-modal-history__container">
        <InputModal
            v-if="inputModal"
            :data="selectedFieldInputModal"
            :isCustomFields="true"
            @setQuantityValue="saveEditedQuantity"
            @close="closeInputModal"
        />
        <material-history-card
            v-for="(register, index) in recordMaterialsModal.history"
            :key="`register-${index}`"
            :register="register"
            :deletable="deletableMaterialIds.has(register.id)"
            :editable="register.actionId === updatedActionId && deletableMaterialIds.has(register.id)"
            @delete="deleteMaterialHistory"
            @edit="openEditModal"
        />
    </div>
</template>

<script>
    import MaterialHistoryCard from "@/views/pages/operator/components/MaterialHistoryCard";
    import InputModal from "@/views/pages/operator/components/InputModal/InputModal.vue";
    import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
    import { mapGetters, mapMutations } from "vuex";
    import materialsStatusEnum from "../../enums/materialsStatus";

    export default {
        components: { MaterialHistoryCard, InputModal, ToastificationContent },
        props: {
            orderId: {
                type: Number,
                required: true
            }
        },
        data: () => ({
            inputModal: false,
            editingRegister: null,
            selectedFieldInputModal: {
                title: "",
                quantityProp: 0
            }
        }),
        computed: {
            ...mapGetters("production_progress", ["recordMaterialsModal"]),
            updatedActionId() {
                return materialsStatusEnum.atualizado;
            },
            deletableMaterialIds() {
                const materials = this.recordMaterialsModal.materials.flatMap((group) => group.materials);
                return new Set(materials.filter((material) => materials.filter((item) => (item.materialId ?? item.id) === (material.materialId ?? material.id)).length === 1).map((material) => material.materialId ?? material.id));
            }
        },
        methods: {
            ...mapMutations("app", ["UPDATE_FLAG_SHOW_OVERLAY"]),
            appointmentQuantity(register) {
                return Math.max(0, (register.newValue || 0) - (register.oldValue || 0));
            },
            historyRecordId(register) {
                return register?.historyId ?? register?.id;
            },
            parseQuantity(value) {
                if (typeof value !== "string") return Number(value) || 0;
                return parseFloat(value.replace(/\./g, "").replace(",", ".")) || 0;
            },
            openEditModal(register) {
                this.editingRegister = register;
                this.selectedFieldInputModal = {
                    title: this.$t("ProductionProgress.ConsumedQuantity"),
                    quantityProp: this.appointmentQuantity(register)
                };
                this.inputModal = true;
            },
            closeInputModal() {
                this.inputModal = false;
                this.editingRegister = null;
            },
            async saveEditedQuantity({ quantity }) {
                const register = this.editingRegister;
                if (!register) return;

                const newQuantity = this.parseQuantity(quantity);

                const historyId = this.historyRecordId(register);
                if (!historyId) return;

                this.UPDATE_FLAG_SHOW_OVERLAY(true);
                try {
                    await this.$http2.put(`/api/mysfc/operation/${register.operationId ?? this.orderId}/materials-history/${historyId}`, {
                        quantityConsumed: newQuantity
                    });
                    this.$emit("updated");
                } catch (error) {
                    this.showToast("Error!", "FrownIcon", error.response?.data?.message, "danger");
                } finally {
                    this.UPDATE_FLAG_SHOW_OVERLAY(false);
                }
            },
            async deleteMaterialHistory(register) {
                const result = await this.$swal({
                    title: this.$t("IntegrationPage.attention"),
                    text: this.$t("OrderTracking.RemoveNoteAlert"),
                    showCancelButton: true,
                    showCloseButton: true,
                    cancelButtonText: this.$t("MySites.cancel"),
                    confirmButtonText: this.$t("ProductionProgress.Remove"),
                    customClass: {
                        container: "swal-default",
                        confirmButton: "btn btn-primary",
                        cancelButton: "btn btn-outline-danger ml-1"
                    },
                    buttonsStyling: false
                });
                if (!result.value) return;

                const historyId = this.historyRecordId(register);
                if (!historyId) return;

                this.UPDATE_FLAG_SHOW_OVERLAY(true);
                try {
                    await this.$http2.delete(`/api/mysfc/operation/${register.operationId ?? this.orderId}/materials-history/${historyId}`);
                    this.$emit("updated");
                } catch (error) {
                    this.showToast("Error!", "FrownIcon", error.response?.data?.message, "danger");
                } finally {
                    this.UPDATE_FLAG_SHOW_OVERLAY(false);
                }
            },
            showToast(title, icon, text, variant) {
                this.$toast({
                    component: ToastificationContent,
                    props: {
                        title,
                        icon,
                        text,
                        variant
                    }
                });
            }
        }
    };
</script>

<style lang="scss" scoped>
    #record-materials-modal {
        .record-materials-modal-history__container {
            display: flex;
            flex-direction: column;
            gap: 16px;
            width: 100%;
            height: 100%;
            overflow-y: auto;
            padding: 24px 29px;

            &::-webkit-scrollbar {
                width: 5px;
            }

            &::-webkit-scrollbar-track {
                background: #fff;
            }

            &::-webkit-scrollbar-thumb {
                background-color: #cfc4be;
                border-radius: 9px;
            }
        }
    }

    @media (max-width: 570px) {
        #record-materials-modal {
            .record-materials-modal-history__container {
                padding: 24px 16px !important;
            }
        }
    }
</style>
